import React from 'react';
import './index.scss';
import { namespaceT } from 'src/viewLayer/helpers/translations';
import { useImprintPath, useTermsPath, usePrivacyPath } from 'src/viewLayer/navigation';

const FooterItem = ({ href, children }) =>
  <a className="footer-item" href={ href }>{ children }</a>;

export default () => {
  const t = namespaceT('common.footer.links');

  return (
    <div className="FooterComponent">
      <FooterItem href={ useImprintPath() }>{ t('imprint.text') }</FooterItem>
      <FooterItem href={ useTermsPath() }>{ t('terms.text') }</FooterItem>
      <FooterItem href={ usePrivacyPath() }>{ t('privacy.text') }</FooterItem>
    </div>
  );
};
